import * as angular from 'angular';
import { ReportTypes } from '@mode/shared/contract-common';

import { format, parseISO } from 'date-fns';
import { HelpDocsService } from '@mode/shared/util-js';

export const DbtDetailsTableComponent: angular.IComponentOptions = {
  controller: class {
    static $inject = ['HelpDocsService'];
    public tables: Array<ReportTypes.DbtDetailTable>;
    public sourceDataLastLoadedAt: Date | string;
    public status: ReportTypes.dbtStateStatus;

    constructor(public helpDocs: HelpDocsService) {}

    getTooltipHtml(dbtTable: ReportTypes.DbtDetailTable) {
      return `<div>
                <div><span>Source name:</span> ${dbtTable.oldestSource}</div>
                <div><span>Refreshed:</span> ${this.getFormattedTimestamp(dbtTable.sourceDataLastLoadedAt)}</div>
              </div>`;
    }

    getFormattedTimestamp(lastLoadedAt: Date | string) {
      const date = typeof lastLoadedAt === 'string' ? parseISO(lastLoadedAt) : lastLoadedAt;
      return format(date, 'MM/dd/yyyy h:mm:ssaaa');
    }

    showInfoOrErrorMessage() {
      return this.status === ReportTypes.dbtStateStatus.info || this.status === ReportTypes.dbtStateStatus.error;
    }
  },
  controllerAs: 'ctrl',
  bindings: {
    tables: '<',
    sourceDataLastLoadedAt: '<',
    status: '<',
    message: '<',
  },
  template: `
  <div class="dbt-details-table-container">
    <div class="dbt-details-header">
      <span class="report-detail-title">
        Source data last refreshed
      </span>
      <span class="icon-dbt-logo"></span>
      <mode-time-ago ng-if="ctrl.sourceDataLastLoadedAt" [date]="ctrl.sourceDataLastLoadedAt"></mode-time-ago>
      <span ng-if="!ctrl.sourceDataLastLoadedAt">Data unavailable</span>
    </div>
    <div class="dbt-details-content">
      <p>
        Listed below is the freshness timestamp for each table in your most recent Report run with a dbt-configured Connection.
        Tables that reference Connections without dbt enabled will not be shown here.
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="{{ ctrl.helpDocs.links['https://mode.com/help/articles/dbt-data-freshness'] }}">
          Learn More
        </a>
      </p>

      <div ng-if="ctrl.showInfoOrErrorMessage()" class="warning-or-error-info">
        <svg-icon
          ng-if="ctrl.status === '${ReportTypes.dbtStateStatus.info}'"
          type="'info-icon'"
          class="warn-icon"
        ></svg-icon>
        <svg-icon
          ng-if="ctrl.status === '${ReportTypes.dbtStateStatus.error}'"
          type="'warning-exclamation-mark'"
          class="error-icon"
        ></svg-icon>
        <strong>{{ ctrl.message }}</strong>
      </div>

      <table class="dbt-details-table">
        <thead>
          <tr>
            <th class="th-name">Table Name</th>
            <th colspan="2">Data last refreshed</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="dbtTable in ctrl.tables" class="dbt-table-row">
            <td class="td-name">{{dbtTable.name}}</td>
            <td class="td-source-loaded-at">
              <mode-time-ago ng-if="dbtTable.sourceDataLastLoadedAt" [date]="dbtTable.sourceDataLastLoadedAt"></mode-time-ago>
              <span
                ng-if="dbtTable.details"
              >{{dbtTable.details}}</span>
              <span
                ng-if="!dbtTable.sourceDataLastLoadedAt && !dbtTable.details"
              >- -</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  `,
};
